export default __webpack_public_path__ + "media/images/14-7c336bdfd66949f1ce18143a73bfa267.jpg";